import React from 'react'

export const Time: React.FC = () => (
  <path d="M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M15.293,16.707L11,12.414V6h2v5.586l3.707,3.707 L15.293,16.707z" />
)
